import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import "./ModalPromocion.scss";
import { getDataPromo } from "../integracion";
import AsignarUnidadModal from "../AsignarUnidad/AsignarUnidadModal";

export default function ModaleditPromo({ visible, onHide, id_promo, onSave, unidadesAsiganadas, onApplyUnits }) {
    const initialFormState = {
        PROMO: "",
        TITULO_BANNER: "",
        SUBTITULO_BANER: "", // Sugerencia: cambialo a SUBTITULO_BANNER
        TITULO_INFORMACION: "",
        NUMERO_COTIZACION: "",
        TEXTO_INFORMACION: "",
        TITULO_CARD1: "",
        CONTENIDO_CARD1: "",
        TITULO_SECCION_IMAGENES: "",
        CONTENIDO_SECCION_IMAGENES: "",
        TITULO_CARD2: "",
        CONTENIDO_CARD2: "",
        TITULO_CARD3: "",
        CONTENIDO_CARD3: "",
        ACTIVO: false
    };

    const initialImagesState = {
        IMAGEN_BANER: null,
        IMAGEN1: null,
        IMAGEN2: null,
        IMAGEN3: null,
        IMAGEN4: null,
        IMAGEN_CARD_1:null,
        IMAGEN_CARD_2:null,
        IMAGEN_CARD_3:null
    };

    const [form, setForm] = useState(initialFormState);
    const [images, setImages] = useState(initialImagesState);
    const [unidadesSeleccionadas, setUnidadesSeleccionadas] = useState([]);
    const [showAsignarUnidades, setShowAsignarUnidades] = useState(false);

    useEffect(() => {
        if (id_promo) {
            getDataPromo(id_promo, setForm, setImages);
        }
    }, [id_promo]);

    useEffect(() => {
        const seleccionInicial = (unidadesAsiganadas || [])
            .filter((unidad) => Number(unidad.PROMO) === Number(id_promo))
            .map((unidad) => Number(unidad.code));
        setUnidadesSeleccionadas(seleccionInicial);
    }, [unidadesAsiganadas, id_promo, visible]);

    const handleInputChange = (e, name) => {
        setForm({ ...form, [name]: e.target.value });
    };

    const handleCheckboxChange = (e) => {
        setForm({ ...form, ACTIVO: e.checked });
    };

    const handleImageChange = (e, name) => {
        const file = e.target.files[0];
        if (file) {
            // Guarda el objeto del archivo en el estado
            setImages({ ...images, [name]: file });
        }
    };
    const handleImageRemove = (name) => {
       
        setImages({ ...images, [name]: null });
    };

    const handleSubmit = () => {
        const data = { campos: form, images: images, unidades: unidadesSeleccionadas };
        onSave(data);
        onHide();
    };

    // Función auxiliar para renderizar los campos de las tarjetas
    const renderCardFields = (cardIndex) => (
        <>
            <span className="p-float-label">
                <InputText
                    id={`TITULO_CARD${cardIndex}`}
                    value={form[`TITULO_CARD${cardIndex}`]}
                    onChange={(e) => handleInputChange(e, `TITULO_CARD${cardIndex}`)}
                />
                <label htmlFor={`TITULO_CARD${cardIndex}`}>Título Tarjeta {cardIndex}</label>
            </span>
            <span className="p-float-label textarea-span">
                <InputTextarea
                    id={`CONTENIDO_CARD${cardIndex}`}
                    rows={2}
                    value={form[`CONTENIDO_CARD${cardIndex}`]}
                    onChange={(e) => handleInputChange(e, `CONTENIDO_CARD${cardIndex}`)}
                />
                <label htmlFor={`CONTENIDO_CARD${cardIndex}`}>Contenido Tarjeta {cardIndex}</label>
            </span>
        </>
    );

    // Función auxiliar para renderizar el componente de subida de imágenes
    const renderImageUpload = (key, label) => (
        <div key={key} className="image-upload-container">
            <label className="image-label">{label}</label>
            <div className="image-preview">
                {images[key] ? (
                    <>
                        {/* Muestra la imagen si existe (puede ser URL o archivo) */}
                        <img
                            src={typeof images[key] === "string" ? images[key] : URL.createObjectURL(images[key])}
                            alt={label}
                        />
                        {/* Botón para eliminar la imagen */}
                        <Button
                            icon="pi pi-times"
                            className="p-button-rounded p-button-danger remove-image-button buttonxsize"
                            onClick={() => handleImageRemove(key)}
                        />
                    </>
                ) : (
                    <div className="image-placeholder">
                        <i className="pi pi-image"></i>
                        <label htmlFor={key} className="p-button p-button-secondary p-button-sm">
                            Seleccionar archivo
                        </label>
                        <input
                            type="file"
                            id={key}
                            accept="image/*"
                            onChange={(e) => handleImageChange(e, key)}
                            style={{ display: "none" }}
                        />
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <Dialog
            header="Editar Promoción"
            visible={visible}
            onHide={onHide}
            className="modal-promocion"
            modal
        >
            <div className="p-fluid">
                <div className="form-section">
                    <h3>Información General</h3>
                    <div className="p-formgrid p-grid">
                        <div className="p-col-12 p-md-6">
                            <span className="p-float-label">
                                <InputText id="PROMO" value={form.PROMO} onChange={(e) => handleInputChange(e, "PROMO")} />
                                <label htmlFor="PROMO">Nombre de la Promoción</label>
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6 checkbox-field">
                            <Checkbox inputId="ACTIVO" checked={form.ACTIVO == 1 ? true : false} onChange={handleCheckboxChange} />
                            <label htmlFor="ACTIVO" style={{ width: "100%" }}>Promoción Activa</label>
                            <span className="p-float-label" style={{ width: "100%" }}>
                                <InputText id="NUMERO_COTIZACION" value={form.NUMERO_COTIZACION} onChange={(e) => handleInputChange(e, "NUMERO_COTIZACION")} />
                                <label htmlFor="NUMERO_COTIZACION">Número de contacto</label>
                            </span>
                            <div className="input" style={{ width: "100%", display: "flex", alignItems: "center", gap: "0.6rem", marginTop: "0.6rem" }}>
                                <Button
                                    type="button"
                                    label="Asignar unidades"
                                    icon="pi pi-sitemap"
                                    className="p-button-outlined"
                                    onClick={() => setShowAsignarUnidades(true)}
                                />
                                {/* <span>Seleccionadas: <strong>{unidadesSeleccionadas.length}</strong></span> */}
                            </div>
                        </div>

                    </div>
                </div>

                <hr />

                <div className="form-section">
                    <h3>Configuración del Banner</h3>
                    <div className="p-formgrid p-grid">
                        <div className="p-col-12 p-md-6">
                            <span className="p-float-label">
                                <InputText id="TITULO_BANNER" value={form.TITULO_BANNER} onChange={(e) => handleInputChange(e, "TITULO_BANNER")} />
                                <label htmlFor="TITULO_BANNER">Título del Banner</label>
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="p-float-label">
                                <InputText id="SUBTITULO_BANER" value={form.SUBTITULO_BANER} onChange={(e) => handleInputChange(e, "SUBTITULO_BANER")} />
                                <label htmlFor="SUBTITULO_BANER">Subtítulo del Banner</label>
                            </span>
                        </div>
                    </div>
                    <div className="containerBaner">
                        <div className="p-col-12 image-preview-banner ">
                            {renderImageUpload("IMAGEN_BANER", "Imagen del Banner")}
                        </div>
                    </div>
                </div>

                <hr />

                <div className="form-section">
                    <h3>Sección de Información</h3>
                    <div className="p-formgrid p-grid">
                        <div className="p-col-12">
                            <span className="p-float-label">
                                <InputText id="TITULO_INFORMACION" value={form.TITULO_INFORMACION} onChange={(e) => handleInputChange(e, "TITULO_INFORMACION")} />
                                <label htmlFor="TITULO_INFORMACION">Título de la Sección</label>
                            </span>
                        </div>
                        <div className="p-col-12">
                            <span className="p-float-label">
                                <InputTextarea id="TEXTO_INFORMACION" rows={3} value={form.TEXTO_INFORMACION} onChange={(e) => handleInputChange(e, "TEXTO_INFORMACION")} />
                                <label htmlFor="TEXTO_INFORMACION">Contenido de la Sección</label>
                            </span>
                        </div>
                    </div>
                </div>

                <hr />

                <div className="form-section">
                    <h3>Contenido de las Tarjetas</h3>
                    <div className="p-formgrid p-grid card-group-cards">
                        <div className="p-col-12 p-md-4 flexColumn">
                             {renderImageUpload("IMAGEN_CARD_1", "Icono tarjeta 1")}
                            <h4>Tarjeta 1</h4>
                            {renderCardFields(1)}
                        </div>
                        <div className="p-col-12 p-md-4 flexColumn">
                             {renderImageUpload("IMAGEN_CARD_2", "Icono tarjeta 2")}
                            <h4>Tarjeta 2</h4>
                            {renderCardFields(2)}
                        </div>
                        <div className="p-col-12 p-md-4 flexColumn">
                             {renderImageUpload("IMAGEN_CARD_3", "Icono tarjeta 3")}
                            <h4>Tarjeta 3</h4>
                            {renderCardFields(3)}
                        </div>
                    </div>
                    <h3>Imágenes</h3>
                    <div className="p-col-12 p-md-4 flexColumn">
                        <span className="p-float-label">
                            <InputText
                                id={`TITULO_SECCION_IMAGENES`}
                                value={form[`TITULO_SECCION_IMAGENES`]}
                                onChange={(e) => handleInputChange(e, `TITULO_SECCION_IMAGENES`)}
                            />
                            <label htmlFor={`TITULO_SECCION_IMAGENES`}>Titulo de la sección de imágenes</label>
                        </span>
                        <span className="p-float-label">
                            <InputText
                                id={`CONTENIDO_SECCION_IMAGENES`}
                                value={form[`CONTENIDO_SECCION_IMAGENES`]}
                                onChange={(e) => handleInputChange(e, `CONTENIDO_SECCION_IMAGENES`)}
                            />
                            <label htmlFor={`CONTENIDO_SECCION_IMAGENES`}>Contenido de la sección de imágenes</label>
                        </span>
                    </div>
                    <div className="p-formgrid p-grid card-group">
                        <div className="p-col-12 p-md-4 flexColumn">
                            {renderImageUpload("IMAGEN1", "Imagen - 1")}
                        </div>
                        <div className="p-col-12 p-md-4 flexColumn">
                            {renderImageUpload("IMAGEN2", "Imagen - 2")}
                        </div>
                        <div className="p-col-12 p-md-4 flexColumn">
                            {renderImageUpload("IMAGEN3", "Imagen - 3")}
                        </div>

                        <div className="p-col-12 p-md-4 flexColumn">
                            {renderImageUpload("IMAGEN4", "Imagen - 4")}
                        </div>

                    </div>
                </div>
            </div>

            <div className="modal-footer">
                <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onHide} />
                <Button label="Guardar" icon="pi pi-check" className="p-button-primary" onClick={handleSubmit} />
            </div>

            <AsignarUnidadModal
                visible={showAsignarUnidades}
                onHide={() => setShowAsignarUnidades(false)}
                onApply={async (payload) => {
                    setUnidadesSeleccionadas(payload.units || []);
                    if (typeof onApplyUnits === "function") {
                        await onApplyUnits(payload);
                    }
                    setShowAsignarUnidades(false);
                }}
                unidades={unidadesAsiganadas || []}
                initialSelected={unidadesSeleccionadas}
                promoId={id_promo}
                promoName={form.PROMO || "promocion actual"}
            />
        </Dialog>
    );
}